import { render, staticRenderFns } from "./DegreeResult.vue?vue&type=template&id=7d74acec&scoped=true&"
import script from "./DegreeResult.vue?vue&type=script&lang=js&"
export * from "./DegreeResult.vue?vue&type=script&lang=js&"
import style0 from "./DegreeResult.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DegreeResult.vue?vue&type=style&index=1&id=7d74acec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d74acec",
  null
  
)

export default component.exports